import { ActionDetailsModalComponent } from './../../components/action-details-modal/action-details-modal.component';
import { IMilestone, IStatus, IActionItems, ITransition, IBudget, ITransitionDetail } from './../home/components/transition/transition.interface';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import { MotifTableModule, MotifDropdownModule, MotifIconModule, ModalSizes, MotifModal } from '@ey-xd/ng-motif';
import { UserService } from 'src/app/services/user/user.service';
import {KeyValue} from '@angular/common';
import { BillableHoursChartData } from 'src/app/interfaces/home.interface';
import { async } from 'rxjs';

@Component({
  selector: 'app-transition-page',
  templateUrl: './transition-page.component.html',
  styleUrls: ['./transition-page.component.scss']
})
export class TransitionPageComponent implements OnInit {
  public engagementId!:string;
  transitions: ITransition[] = [];
  selectedTransitionId: string = '';
  currentDate = new Date();
  firstUpcomingMilestone!: IMilestone;
  visibleTransition: ITransitionDetail = {
    transition: {
      id: 0,
      projectName: '',
      rag: '',
      clientName: '',
      projectStart: this.currentDate,
      projectEnd: this.currentDate,
      headerImageUrl: '',
      projectTypeIconUrl: '',
      projectDescription: '',
      isDisplayed: false,
      bannerImageUrl: '',
    },
    highPriority: {
      Risks: [],
      Actions: [],
      Issues: [],
      Dependency: [],
    },
    projectBudget: {
      overallBudget: 80,
      costIncurred: 60,
      estimateCompletion: 100,
      percentOfChange: '0',
      // isPositive: e.budget.estimateCompletion < e.budget.overallBudget}
      isPositive: false
    },
    projectTollgate: [],
    milestone: []
  };
  mileStoneTimelines = ['All', 'Past','Upcoming', 'Future']
  selectedMilestoneTimeline = 'All'
  sortedMonthYears:string[] = [];
  budget:IBudget= {
    overallBudget:80,
    costIncurred:60,
    estimateCompletion:100,
    percentOfChange: this.setPercentOfChangeInBudget(80, 100),
    // isPositive: e.budget.estimateCompletion < e.budget.overallBudget}
    isPositive:false
    
  }
  allMilestones:IMilestone[] = [];
  visibleMileStones:IMilestone[] = [];
  warningIcon: any;
  loading = false;
  @Input() data: any = {
    'clientId': '',
    'transitionId': '',
    'isModal': false
  };
  sortedMilestones!: Record<string, IMilestone[]>;
  
  public initializeChart = false;
  width = 30;
  height = 30;
  strokeWidth = '1';
  billableHoursChartData: BillableHoursChartData[] = [];
  
  constructor(
    public motifIconModule : MotifIconModule, public userService: UserService, public modal: MotifModal,private router:Router,private route: ActivatedRoute, private homeServiceRef: HomeService, private motifTableModule: MotifTableModule) {  }

  ngOnInit(): void {
    // this.sortedMilestones = this.sortMilestonesByMonth();
    const id = this.route.snapshot.paramMap.get('id');    
    this.selectedTransitionId = this.route.snapshot.paramMap.get('transitionId')?.toString() || this.data.transitionId.toString();
    this.engagementId = id || this.data.clientId;
    this.loading = true;
    this.homeServiceRef.getTransitions(this.engagementId).subscribe((res) => {
      // this.transitions = res.filter((e:ITransition)=> e.isDisplayed).map((e:ITransition)=> ({...e, rag:this.setRAG(e.rag), projectDescription: "This project involves the transition of the AMS Portfolio for TEVA, which includes ERP, FAS and PAS applications.", status: this.setStatus(), milestones: this.sortedMilestones, budget: this.budget}));
      this.transitions = res.filter((e:ITransition)=> e.isDisplayed);
      if(!this.selectedTransitionId){
        this.selectedTransitionId = this.transitions[0].id.toString();
      }
      this.getTransitionDetailsById();
      // this.setPercentOfChangeInBudget();
      // this.getTransitionDetailsById(this.selectedTransitionId);
    });
  }

  showMilestones(timeline:string){
    this.selectedMilestoneTimeline = timeline;
    this.sortMilestonesByMonth()
  }
  setPercentOfChangeInBudget(overallBudget:number, estimateCompletion:number) : string{
    const percent =((Math.abs(overallBudget - estimateCompletion)/overallBudget)*100).toFixed(2);
    console.log(percent)
   return percent;
  }

  openDetailsModal(key: string, actionItems:IActionItems[]){
    const modalRef = this.modal.open(ActionDetailsModalComponent, {
      size: ModalSizes.SM,
      data: {items: actionItems,
      itemHeader: key
      }
    });
    modalRef.componentInstance.data = {items: actionItems,
      itemHeader: key
      };
    modalRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  setStatus(): IStatus{
    return {
      'Risks': this.setActionItems(), 
      'Actions': this.setActionItems(), 
      'Dependency': this.setActionItems(), 
      'Issues': this.setActionItems()
    }
  }
  setActionItems() : IActionItems[]{
    return [{
      name: 'ERP- SME for SD Unavailable',
      assignedUserName: 'David Herman',
      assignedUserEmail: 'davidherman@ey.com',
      dueDate: '25/08/2025',
      priority: 'HIGH'
    },
    {
      name: 'ERP- SME for SD Unavailable',
      assignedUserName: 'Emily Gotz Herman',
      assignedUserEmail: 'emilygotz@ey.com',
      dueDate: '28/08/2025',
      priority: 'MEDIUM'
    }]
  }
  sortMilestonesByMonth() {
    // let milestones = [
    //   {
    //     milestoneDetail: 'PAS KT Completed',
    //     startDate: '1/10/2024',
    //     endDate: '1/10/2024',
    //   },
    //   {
    //     milestoneDetail: 'PAS Shadow Phase Completed',
    //     startDate: '03/10/2024',
    //     endDate: '03/21/2024',
    //   },
    //   {
    //     milestoneDetail: 'ERP Resource Onboarding Completed',
    //     startDate: '11/10/2024',
    //     endDate: '11/21/2024',
    //   },
    //   {
    //     milestoneDetail: 'PAS Go Live',
    //     startDate: '02/10/2025',
    //     endDate: '02/21/2025',
    //   },
    //   {
    //     milestoneDetail: 'ERP Shadow Phase Completed',
    //     startDate: '04/10/2025',
    //     endDate: '04/21/2025',
    //   },
    // ];
    const sortedMilestones: Record<string, IMilestone[]> = {};
    if(this.allMilestones.length){
      if(this.selectedMilestoneTimeline === 'Past'){
        this.visibleMileStones = (this.allMilestones.filter(m=> m.isPast))
      }else if(this.selectedMilestoneTimeline === 'Upcoming'){
        this.visibleMileStones = (this.allMilestones.filter(m=> m.isUpcoming))
      }else if(this.selectedMilestoneTimeline === 'Future'){
        this.visibleMileStones = (this.allMilestones.filter(m=> !m.isPast && !m.isUpcoming))
      } else {
        this.visibleMileStones = structuredClone(this.allMilestones);
      }
      this.visibleMileStones.forEach(milestone => {
        const date = new Date(milestone.startDate);
        const day = date.getDate();
        const month = date.getMonth() + 1; // Months are zero-based, so we add 1
        const year = date.getFullYear();
        const monthYearKey = `${this.getMonthName(month)} ${year}`;

        if (!sortedMilestones[monthYearKey]) {
          sortedMilestones[monthYearKey] = [];
        }

        sortedMilestones[monthYearKey].push(milestone);
      });
  }

  this.sortedMilestones = structuredClone(sortedMilestones);
  this.getSortedMonthYears();
  }
  public getFirstUpcomingMilestone(milestones: IMilestone[]): any | null {

    for (const milestone of milestones) {
      const startDate = new Date(milestone.startDate);
        if (startDate > this.currentDate && (!this.firstUpcomingMilestone || startDate < new Date(this.firstUpcomingMilestone.startDate))) {
          this.firstUpcomingMilestone = milestone;
        }
    }
  }
  getSortedMonthYears() {
    this.sortedMonthYears = Object.keys(this.sortedMilestones).sort((a, b) => {
      const dateA = new Date(parseInt(a.split(' ')[1]), this.getMonthIndex(a.split(' ')[0]));
      const dateB = new Date(parseInt(b.split(' ')[1]), this.getMonthIndex(b.split(' ')[0]));
      return +dateA - +dateB; 
    });
  }
  getMonthIndex(monthName: string): number {
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return monthNames.indexOf(monthName);
  }
getMonthName(monthIndex: number): string {
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return monthNames[monthIndex - 1];
  }

  setRAG(rag:String) : String{
    switch (rag){
      case 'OnTrack': return 'On Track'
      case 'AtRisk': return 'At Risk'
      case 'Delayed': return 'Delayed'
      default: return rag;
      break;
      }
  }
  setSelectedTransition(id:number){
    this.selectedTransitionId = id.toString();
    this.getTransitionDetailsById()
  }
  getTransitionDetailsById(){
    this.loading = true;
    this.homeServiceRef.getTransitionById(this.engagementId,this.selectedTransitionId).subscribe(async (res) => {
      this.billableHoursChartData = [...this.billableHoursChartData,  
        {
          id: 1,
          color: '#487dc1',
          value:res.transition.projectCompletion
        },
        {
          id: 2,
          color: 'transparent',
          value: (100-res.transition.projectCompletion)
        }]
      await this.getFirstUpcomingMilestone(res.milestone);
      this.allMilestones = res.milestone.length? res.milestone.map((m:IMilestone)=> ({...m, isPast: new Date(m.startDate) <this.currentDate, isUpcoming:this.firstUpcomingMilestone && this.firstUpcomingMilestone.milestoneDetail && m.milestoneDetail === this.firstUpcomingMilestone.milestoneDetail && m.startDate === this.firstUpcomingMilestone.startDate})): [];
      await this.sortMilestonesByMonth();
      // this.transitions = res.filter((e:ITransition)=> e.isDisplayed).map((e:ITransition)=> ({...e, rag:this.setRAG(e.rag), projectDescription: "This project involves the transition of the AMS Portfolio for TEVA, which includes ERP, FAS and PAS applications.", status: this.setStatus(), milestones: this.sortedMilestones, budget: this.budget}));
      this.visibleTransition = ({...res, transition: {...res.transition, rag:this.setRAG(res.transition.rag)}, milestones: this.sortedMilestones, projectBudget: res.projectBudget?{...res.projectBudget,percentOfChange: this.setPercentOfChangeInBudget(res.projectBudget.overallBudget, res.projectBudget.estimateCompletion), isPositive: res.projectBudget.estimateCompletion < res.projectBudget.overallBudget }: null});
      // this.setPercentOfChangeInBudget();
      this.loading = false;      
      // this.getTransitionDetailsById(this.selectedTransitionId);
    });  
  }
  goHome()
  {
    this.router.navigate([`/home`, this.engagementId]);
  }

}
